// extracted by mini-css-extract-plugin
export var book = "home-book-module--book--913a1";
export var book__imgs = "home-book-module--book__imgs--81f9d";
export var book__imgs1 = "home-book-module--book__imgs1--80e72";
export var book__imgs2 = "home-book-module--book__imgs2--c12ff";
export var book__imgs3 = "home-book-module--book__imgs3--21dfe";
export var book__imgs4 = "home-book-module--book__imgs4--18a51";
export var book__imgs5 = "home-book-module--book__imgs5--40c56";
export var book__imgs6 = "home-book-module--book__imgs6--8f736";
export var book__imgs7 = "home-book-module--book__imgs7--30fcc";
export var book__imgs8 = "home-book-module--book__imgs8--9116d";
export var book__imgs9 = "home-book-module--book__imgs9--c80cb";
export var book__imgsEl = "home-book-module--book__imgs-el--ef4eb";
export var book__imgsItem = "home-book-module--book__imgs-item--ef8d5";
export var book__link = "home-book-module--book__link--275d1";
export var book__linkImg = "home-book-module--book__link-img--f9c6a";
export var book__txt = "home-book-module--book__txt--2f372";
export var book__wrapp = "home-book-module--book__wrapp--5fe9b";